module.exports = __webpack_public_path__ + "img/z2.f614ea86.jpg";